import './tokens.css'


export default function HandleToken({token, lemma, annotation,  UD,  index, targetIndex}) {

    return (
             <span className={index === targetIndex  ? "tok target" : "tok"}><b>{token}</b> <span className="ext">lemma: <i>{lemma}</i><br/>
               Annotation: <b>{annotation}</b><br/>
               UD: <b>{UD}</b><br/>
             </span> </span>
    )
    }
